export enum PersonModal {
    PERSON_CREATE_MODAL = 'personCreateModal',
    PERSON_UPDATE_MODAL = 'personUpdateModal',
    PERSON_DELETE_MODAL = 'personDeleteModal'
}
